// Modal event handlers for callback form.
// Bootstrap handles open/close. This file only wires submit/focus/reset behavior.
(function () {
    'use strict';

    function toLocalDateTimeValue(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    function initCallbackModal() {
        const modalElement = document.getElementById('callbackModal');
        if (!modalElement || modalElement.dataset.callbackModalInitialized === 'true') {
            return;
        }
        modalElement.dataset.callbackModalInitialized = 'true';

        const submitBtn = document.getElementById('callbackModalSubmitBtn');
        if (submitBtn) {
            submitBtn.addEventListener('click', function (e) {
                e.preventDefault();
                const form = modalElement.querySelector('form');
                if (form) {
                    if (typeof form.requestSubmit === 'function') {
                        form.requestSubmit();
                    } else {
                        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                }
            });
        }

        modalElement.addEventListener('shown.bs.modal', function () {
            const nameInput = modalElement.querySelector('input[name="Fields[name]"]');
            if (nameInput) {
                nameInput.focus();
            }

            const convenientTimeInput = modalElement.querySelector('input[name="Fields[convenientTime]"]');
            if (convenientTimeInput && !convenientTimeInput.value) {
                convenientTimeInput.value = toLocalDateTimeValue(new Date());
                convenientTimeInput.dispatchEvent(new Event('input', { bubbles: true }));
                convenientTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        modalElement.addEventListener('hidden.bs.modal', function () {
            const form = modalElement.querySelector('form');
            if (!form) {
                return;
            }

            form.reset();
            if (window.FormSubmitState) {
                window.FormSubmitState.reset(form);
            } else {
                form.querySelectorAll('.form-error')
                    .forEach(function (el) { el.classList.add('form-error--hidden'); });
            }
        });
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initCallbackModal);
        } else {
            initCallbackModal();
        }

        if (typeof window !== 'undefined') {
            window.initCallbackModal = initCallbackModal;
        }
    }
})();
